import { Container, Col, Row } from "react-bootstrap";
import Coming from "../../components/Layout/Coming/Coming";
import Footer from "../../components/Layout/Footer/Footer";
import "../../components/Layout/Jumbotron/JumbotronII";

const DriversPage = () => {
  return (
    <div>
      <Container className="JumboBGII" fluid>
        <div className="OverlayII">
          <Row>
            <Col className="text-center">
              <h1>DRIVERS</h1>
            </Col>
          </Row>
        </div>
      </Container>
      <Coming />
      <Footer />
    </div>
  );
};

export default DriversPage;
